export function SuperAdminConsolePage() {
  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <h1 className="h4 mb-0">Super Admin · Console</h1>
          <p className="text-muted mb-0">
            Next: port `super_admin/templates/super_admin/summary.html` and wire to `/api/super_admin/*`.
          </p>
        </div>
      </div>
    </div>
  );
}

